<template>
  <div>
    <h5 class="text-primary mt-4">CAMBIO DE CONDICIÓN FISCAL</h5>
    <b-tabs class="mt-3">
      <b-tab title="Condición de IVA">
        <b-row>
          <b-col>
            <b-form-group label="CUIT / CUIL:">
              <b-form-input
                v-model="iva.numero"
                type="text"
                v-mask="'##-########-#'"
                placeholder="XX-XXXXXXXX-X"
                @blur="$v.iva.numero.$touch"
                :state="$v.iva.numero.$dirty ? !$v.iva.numero.$error : null"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Condición">
              <b-form-select
                v-model="iva.condicion"
                :options="condicionesIva"
                @blur="$v.iva.condicion.$touch"
                :state="$v.iva.condicion.$dirty ? !$v.iva.condicion.$error : null"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Comprobante:">
              <b-form-file
                v-model="iva.adjunto"
                placeholder="Adjuntar archivo"
                accept="image/*, application/pdf"
                @blur="$v.iva.adjunto.$touch"
                :state="$v.iva.adjunto.$dirty ? !$v.iva.adjunto.$error : null"
              ></b-form-file>
            </b-form-group>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab title="Condición de IIBB">
        <b-row>
          <b-col>
            <b-form-group label="Número Inscripción IIBB:">
              <b-form-input
                v-model="iibb.numero"
                type="text"
                v-mask="'##-########-#'"
                placeholder="XX-XXXXXXXX-X"
                @blur="$v.iibb.numero.$touch"
                :state="$v.iibb.numero.$dirty ? !$v.iibb.numero.$error : null"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Condición:">
              <b-form-select
                v-model="iibb.condicion"
                :options="condicionesIb"
                @blur="$v.iibb.condicion.$touch"
                :state="$v.iibb.condicion.$dirty ? !$v.iibb.condicion.$error : null"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Comprobante:">
              <b-form-file
                v-model="iibb.adjunto"
                placeholder="Adjuntar archivo"
                accept="image/*, application/pdf"
                @blur="$v.iibb.adjunto.$touch"
                :state="$v.iibb.adjunto.$dirty ? !$v.iibb.adjunto.$error : null"
              ></b-form-file>
            </b-form-group>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>
    <div class="submit-footer">
      <b-row>
        <b-col></b-col>
        <b-col class="text-right">
          <b-btn
            variant="success"
            @click="submit"
            v-b-tooltip.hover
            title="La presente solicitud está sujeta a aprobación. Los cambios no se guardarán de manera instantánea."
          >
            <i class="fa fa-send-o" v-if="!sending"></i>
            <i class="fa fa-spinner fa-spin" v-else></i>
            Enviar Solicitud
          </b-btn>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { requiredIf } from 'vuelidate/lib/validators';
import ValidacionCuit from '@/helpers/ValidacionCuit';
export default {
  props: ['tomador', 'nroPoliza'],
  data() {
    return {
      sending: false,
      iibb: {
        numero: '',
        condicion: '',
        adjunto: null
      },
      iva: {
        numero: '',
        condicion: '',
        adjunto: null
      }
    };
  },
  validations: {
    iva: {
      numero: {
        required: requiredIf(function() {
          return this.iva.condicion.length || this.iva.adjunto || this.allEmpty;
        }),
        ValidacionCuit
      },
      condicion: {
        required: requiredIf(function() {
          return this.iva.numero.length || this.iva.adjunto || this.allEmpty;
        })
      },
      adjunto: {
        required: requiredIf(function() {
          return this.iva.numero.length || this.iva.condicion.length || this.allEmpty;
        })
      }
    },
    iibb: {
      numero: {
        required: requiredIf(function() {
          return this.iibb.condicion.length || this.iibb.adjunto || this.allEmpty;
        })
      },
      condicion: {
        required: requiredIf(function() {
          return this.iibb.numero.length || this.iibb.adjunto || this.allEmpty;
        })
      },
      adjunto: {
        required: requiredIf(function() {
          return this.iibb.numero.length || this.iibb.condicion.length || this.allEmpty;
        })
      }
    }
  },
  methods: {
    submit: async function() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return null;
      }

      const fd = new FormData();

      // agregar datos del formulario de iva
      if (Object.values(this.iva).every(el => el)) {
        const ivaAttachment = this.iva.adjunto;
        const { adjunto, ...iva } = this.iva;
        fd.append('iva', JSON.stringify(iva));
        fd.append('iva_attachment', ivaAttachment);
      }

      // agregar datos del formulario de iibb
      if (Object.values(this.iibb).every(el => el)) {
        const iibbAttachment = this.iibb.adjunto;
        const { adjunto, ...iibb } = this.iibb;
        fd.append('iibb', JSON.stringify(iibb));
        fd.append('iibb_attachment', iibbAttachment);
      }

      // agregar datos del pas y póliza
      fd.append(
        'pas',
        JSON.stringify({
          nombre: (this.$store.state.auth.nombre + ' ' + this.$store.state.auth.apellido).replace('null',''),
          codigo: this.$store.state.auth.codigo || this.$store.state.auth.cod_agente,
          email: this.$store.state.auth.email
        })
      );
      fd.append('poliza', this.nroPoliza);

      // enviar solicitud
      this.sending = true;
      await this.$api
        .post(`endoso/solicitud/cambio-condicion-fiscal/${this.tomador}`, fd, {
          headers: {
            'Content-type': 'multipart/form-data'
          }
        })
        .then(() => {
          this.$toast.success(`Solicitud de endoso enviada correctamente.`);
        })
        .catch(err => {
          //console.log(err.response);
          this.$toast.error('Ocurrió un error al enviar la solicitud.');
        });
      this.sending = false;
    }
  },

  computed: {
    condicionesIva() {
      return this.$store.state.condicionesIva;
    },
    condicionesIb() {
      return this.$store.state.condicionesIIBB;
    },
    allEmpty() {
      return !Object.values(this.iva).some(el => el) && !Object.values(this.iibb).some(el => el);
    }
  }
};
</script>
